export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <h4 className="font-heading text-lg text-background-50 mb-3">91影视看片app</h4>
            <p className="text-sm text-background-400 leading-relaxed">
              91影视看片app是一款免费高清影视在线观看应用，提供安卓版与苹果版安装包下载。覆盖热门电影、电视剧、综艺、动漫等海量资源，每日更新，随时随地畅享流畅观影体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-3">快速导航</h4>
            <div className="flex flex-col gap-2">
              <a href="#app" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer no-underline">APP下载</a>
              <a href="#cards" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer no-underline">热门推荐</a>
              <a href="#carousel" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer no-underline">焦点专题</a>
              <a href="#faq" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer no-underline">常见问题</a>
              <a href="#ranking" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer no-underline">热播榜单</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-3">版本支持</h4>
            <div className="flex flex-col gap-2">
              <span className="text-sm text-background-400">
                <i className="ri-android-line mr-1.5"></i>安卓最新版本
              </span>
              <span className="text-sm text-background-400">
                <i className="ri-apple-line mr-1.5"></i>苹果iOS版本
              </span>
              <span className="text-sm text-background-400">
                <i className="ri-smartphone-line mr-1.5"></i>兼容主流机型
              </span>
              <span className="text-sm text-background-400">
                <i className="ri-shield-check-line mr-1.5"></i>安全无病毒
              </span>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-3">合作伙伴</h4>
            <div className="flex flex-wrap gap-3">
              <span className="text-xs text-background-500 px-3 py-1.5 rounded-full border border-background-800 whitespace-nowrap">影视内容合作</span>
              <span className="text-xs text-background-500 px-3 py-1.5 rounded-full border border-background-800 whitespace-nowrap">技术平台支持</span>
              <span className="text-xs text-background-500 px-3 py-1.5 rounded-full border border-background-800 whitespace-nowrap">分发渠道合作</span>
            </div>
          </div>
        </div>

        <div className="border-t border-background-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 91影视看片app. 本站为官方下载页面，免费提供91影视看片app安卓版与苹果版安装包。
          </p>
          <p className="text-xs text-background-600">
            高清影视在线观看 · 免费追剧神器 · 每日更新不等待
          </p>
        </div>
      </div>
    </footer>
  );
}